import React, { memo } from 'react';

import { Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { rejectionReasonStyles } from './RejectionReasonModal.styles';

const RejectionReasonModal = ({ rejectionReason }) => (
  <Typography sx={rejectionReasonStyles} variant="regular14">
    {rejectionReason}
  </Typography>
);

RejectionReasonModal.propTypes = {
  rejectionReason: PropTypes.string,
};

export default memo(RejectionReasonModal);
